export default __webpack_public_path__ + "static/media/camera.4332ef25.svg";